var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--menus_left"
  }, [_c('div', {
    staticClass: "bg-white box-rounded shadowed overflow-hidden"
  }, [_c('div', [_vm.forUser ? [_c('UserBox', {
    staticClass: "border-b border-b-solid color-border-bottom-lighter mb-30",
    attrs: {
      "user-name": _vm.userName,
      "user-rank-title": _vm.userStatusTitle,
      "user-rank-image-url": _vm.userStatusImageUrl
    }
  })] : [_c('h3', {
    staticClass: "left-menu-title typo-h2 px-30 py-25 mb-30 border-b border-b-solid color-border-bottom-lighter"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])], _vm._v(" "), _c('ul', {
    staticClass: "d-grid gap-10 px-30 pb-30"
  }, _vm._l(_vm.leftMenu, function (item, index) {
    return _c('li', {
      key: index
    }, [item.route && item.isExternalRoute ? [_c('a', {
      staticClass: "menu-item typo-h5 color-text-secondary text-decoration-none display-flex px-20 py-5px",
      attrs: {
        "href": item.route,
        "data-testid": `${item.key}-button`,
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(item.key)) + "\n            ")])] : [_c('nuxt-link', {
      staticClass: "menu-item typo-h5 color-text-secondary text-decoration-none display-flex px-20 py-5px",
      attrs: {
        "to": _vm.localePath(item.route),
        "data-testid": `${item.key}-button`
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.clickHandler(item);
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(item.key)) + "\n            ")])]], 2);
  }), 0)], 2)]), _vm._v(" "), _vm.logOutItem ? _c('div', [_c('div', {
    staticClass: "px-30 mt-30 display-none display-lg-block"
  }, [_c('a', {
    staticClass: "left-menu-logout typo-p color-text-red display-flex justify-content-start align-items-center text-decoration-none cursor-pointer",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onClickLogout.apply(null, arguments);
      }
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t('components.main.navigation.logout')) + "\n        ")]), _vm._v(" "), _c('span', {
    class: ['display-flex', {
      'ml-10': _vm.$dir() === 'ltr',
      'mr-10': _vm.$dir() === 'rtl'
    }]
  }, [_c('span', {
    class: ['airalo-icon-log-out tw-text-4', {
      'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
    }]
  })])])])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }